import { render, staticRenderFns } from "./BucketFilter.vue?vue&type=template&id=53204c9c"
import script from "./BucketFilter.vue?vue&type=script&lang=js"
export * from "./BucketFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports